// src/pages/HomePage.jsx
import React, { useState, useEffect } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { groupIcons } from '../components/GroupIcons'

export default function HomePage() {
  const [groups, setGroups] = useState([])
  const [products, setProducts] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  const [suggestions, setSuggestions] = useState([])
  const [showDropdown, setShowDropdown] = useState(false)
  const navigate = useNavigate()
  const API = process.env.REACT_APP_API_URL

  useEffect(() => {
    fetch(`${API}/product-groups`)
      .then(r => r.ok ? r.json() : Promise.reject(new Error(`HTTP ${r.status}`)))
      .then(setGroups)
      .catch(err => console.error('product-groups fetch failed:', err));
    fetch(`${API}/products`)
      .then(r => r.ok ? r.json() : Promise.reject(new Error(`HTTP ${r.status}`)))
      .then(setProducts)
      .catch(err => console.error('products fetch failed:', err));
  }, [API])

function slugify(str) {
  return str
    .toLowerCase()
    .replace(/\s|\//g, '') // fjern mellomrom og skråstrek
    .replace(/&/g, '')     // fjern &
    .replace(/æ/g, 'ae').replace(/ø/g, 'o').replace(/å/g, 'a')
    .replace(/[^a-z0-9]/g, ''); // fjern andre spesialtegn
}

  useEffect(() => {
    if (!searchTerm.trim()) {
      setSuggestions([])
      return
    }
    const term = searchTerm.toLowerCase()
    const prodMatches = products
      .filter(p => p.name.toLowerCase().includes(term))
      .slice(0, 8)
      .map(p => ({ type: 'product', id: p.id, name: p.name }))
    setSuggestions(prodMatches)
  }, [searchTerm, products])

  // Del opp i 2 rader á 3 ikoner
  const firstRow = groups.slice(0, 3)
  const secondRow = groups.slice(3, 6)

  return (
    <div className="max-w-screen-xl mx-auto p-6 space-y-6">
      <h1 className="text-4xl font-bold text-[#000099] text-center">
        Alt du trenger på ett sted
      </h1> 
      <h3 className="text-1xl text-[#000099] text-center">
                Trenger du hjelp til flytting og/eller lagring, ta kontakt med oss{' '}
        <Link to="/contact" className="underline hover:text-blue-700">
          her!
        </Link>
      </h3>

      {/* Søkefelt */}
      <div className="relative w-full max-w-xl mx-auto">
        <input
          type="text"
          placeholder="Søk etter produkt…"
          value={searchTerm}
          onChange={e => { setSearchTerm(e.target.value); setShowDropdown(true) }}
          onFocus={() => setShowDropdown(true)}
          className="w-full border border-gray-300 rounded-lg px-6 py-3 text-lg focus:outline-none focus:ring-2 focus:ring-[#000099]"
        />
        {showDropdown && suggestions.length > 0 && (
          <ul className="absolute z-10 w-full bg-white border border-gray-200 rounded-b-lg shadow-lg mt-1 max-h-60 overflow-auto">
            {suggestions.map(item => (
              <li
                key={item.id}
                onMouseDown={() => {
                  setShowDropdown(false)
                  setSearchTerm('')
                  navigate(`/product/${item.id}`)
                }}
                className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
              >
                <span className="font-medium">🔍 </span>
                {item.name}
              </li>
            ))}
          </ul>
        )}
      </div>

      {/* 3 + 3 ikoner, større */}
      <div className="flex flex-col items-center gap-10">
        {[firstRow, secondRow].map((row, idx) => (
          <div key={idx} className="flex flex-row justify-center gap-12">
            {row.map(g => {
              const slug = g.slug || slugify(g.name)
              const icon = groupIcons[slug] || '/icons/default.svg'
              return (
                <button
                  key={g.id}
                  onClick={() => navigate((g?.id === 6 || (slug === 'lager')) ? '/boder' : `/group/${g.id}`)}
                  className="bg-transparent border-none outline-none shadow-lg rounded-2xl transition-transform hover:scale-110 cursor-pointer p-0"
                  style={{ boxShadow: '0 6px 24px 0 rgba(0,0,0,0.10)' }}
                  aria-label={g.name}
                >
                  <img
                    src={icon}
                    alt={g.name}
                    className="w-[8.5rem] h-[8.5rem] sm:w-[9rem] sm:h-[9rem]"
                    loading="lazy"
                    draggable={false}
                  />
                </button>
              )
            })}
          </div>
        ))}
      </div>
    </div>
  )
}
